export const FETCH_DEPOSIT_PENDING = "FETCH_DEPOSIT_PENDING";
export const FETCH_DEPOSIT_PENDING_SUCCESS = "FETCH_DEPOSIT_PENDING_SUCCESS";